export default __webpack_public_path__ + "static/media/IBMAdd.8787de85.svg";